import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export default new VueI18n({
    locale: 'nl',
    messages: {
        nl: {
            'x bijlagen': 'Geen bijlagen | 1 bijlage | {count} bijlagen',
        }
    },
    silentTranslationWarn: true,
});